import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"updateSyncInfo"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`channel`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#resourceidentifier"
          }}>{`ResourceIdentifier`}</a>{` to a `}<a parentName="li" {...{
            "href": "/api/../api/projects/channels#channel"
          }}>{`Channel`}</a><br parentName="li"></br>
          {`Connection to a particular synchronization destination.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`externalId`}</inlineCode>{` - String - Optional`}<br parentName="li"></br>
          {`Can be used to reference an external order instance, file etc.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`syncedAt`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#datetime"
          }}>{`DateTime`}</a>{` - Optional
If not provided, then current date would be used`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      